export class ExportHeaders {
  Carteira: string ;
  Contrato: string ;
   Corretora: string ;
  DataOperacao: string ;
  Status: string ;
  Modalidade: string ;
  Opercao: string ;
  Papel: string ;
  Quantidade: string ;
  Quantidade_ON6: string ;
  TaxaCliente: string ;
  TaxaCorretora: string ;
  perCliente: string ;
  perCorretora : string;
}
